import ScoreBoxCricket from "./ScoreBoxCricket";
export default ScoreBoxCricket;
